export default __webpack_public_path__ + "media/packs/images/pcibex-y-15ef29ac2faaeb22b28353c647cb4e55.png";